import { render, staticRenderFns } from "./ReturnPartsView.vue?vue&type=template&id=b9b3eaa8"
import script from "./ReturnPartsView.vue?vue&type=script&lang=js"
export * from "./ReturnPartsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b9b3eaa8')) {
      api.createRecord('b9b3eaa8', component.options)
    } else {
      api.reload('b9b3eaa8', component.options)
    }
    module.hot.accept("./ReturnPartsView.vue?vue&type=template&id=b9b3eaa8", function () {
      api.rerender('b9b3eaa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/returnparts/ReturnPartsView.vue"
export default component.exports